import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AddressApproval {
  [address: string]: boolean;
}

export interface Approvals {
  loading: boolean;
  data: AddressApproval;
}

export interface NFTReducerState {
  approvals: Approvals;
  numTokens?: number;
}

const initialState: NFTReducerState = {
  approvals: {
    loading: true,
    data: {},
  },
  numTokens: undefined,
};

export const nftSlice = createSlice({
  name: 'nft',
  initialState,
  reducers: {
    storeCheckedApprovals: (state, action: PayloadAction<AddressApproval>): void => {
      state.approvals = {
        loading: false,
        data: action.payload,
      };
    },
    storeApproval: (state, action: PayloadAction<{ address: string; isApproved: boolean }>): void => {
      const { address, isApproved } = action.payload;
      state.approvals.data[address] = isApproved;
    },
    storeNumTokens: (state, action: PayloadAction<number>): void => {
      state.numTokens = action.payload;
    },
  },
});
